import React from 'react';
import user from '../../assets/ic-user.svg';
import viewsIcn from '../../assets/views-icon.svg';
import clockIcn from '../../assets/ic-clock.svg';

import styles from './LiveShowCollection.module.css';
import { formatDate, getInitial } from '../../utils';

const LiveShowCollection = ({
  data,
  empty,
  onLiveshowCLicked,
  sliderItem,
  customStyle,
}) => {
  const thumbnail =
    data && data.thumbnail
      ? `url(${data.thumbnail})`
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.32) 30.23%, rgba(0, 0, 0, 0.88) 100%)';

  const style = data && {
    background: `${thumbnail} no-repeat center center`,
    backgroundSize: 'cover',
    backgroundColor: 'white',
  };

  const MediaItem = ({ item }) => {
    return (
      <div
        title={item.titleLocalized || item.nameLocalized}
        className={styles['item-image']}
        style={style}
        key={item.id}
        onClick={() => onLiveshowCLicked(item)}
      >
        <div
          style={{
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.32) 30.23%, rgba(0, 0, 0, 0.72) 100%)',
            transform: 'matrix(1, 0, 0, -1, 0, 0)',

            position: 'absolute',
            top: '0%',
            left: '0%',
            right: '0%',
            width: '100%',
            height: '50%',
            opacity: '0.7',
          }}
        ></div>
        <div
          style={{
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.32) 30.23%, rgba(0, 0, 0, 0.88) 100%)',
            //transform: 'matrix(1, 0, 0, -1, 0, 0)',

            position: 'absolute',
            left: '0%',
            right: '0%',
            bottom: '0%',
            width: '100%',
            height: '50%',
            opacity: '0.8',
          }}
        ></div>
        <div className={styles['item-header']}>
          {data.type === 'liveshow-vod' ? (
            data.finishedAt && (
              <div className={styles['date']}>
                <img src={clockIcn} alt='clock' />
                <span>{formatDate(data.finishedAt)}</span>
              </div>
            )
          ) : (
            <>
              <div className={styles['live-indicator']}>
                <div className={styles['red-dot']}></div>
                <div>LIVE</div>
              </div>
              <div className={styles['info-badge']}>
                <img src={viewsIcn} alt='views-icon' width='20' />
                <span className={styles['info-list']}>{item.viewers}</span>
              </div>
            </>
          )}
        </div>
        <div className={styles['info-item']}>
          <div className={styles['title-item']}>
            <div className={styles['genre']}>
              {item && item.showCategory && item.showCategory.name}
            </div>
          </div>
          <div
            className={`${styles['title']} ${
              item.name.indexOf(' ') >= 0 && styles['title-max-2-line']
            }`}
          >
            {item.name}
          </div>
          <div className={styles['profile']}>
            <div className={styles.avatar}>
              {item?.profile?.avatar ? (
                <img src={item.profile.avatar || user} alt='Avatar' />
              ) : (
                <div className={styles['user-profile-icon']} data-initial-name>
                  {getInitial(item?.profile?.name || '')}
                </div>
              )}
            </div>
            <span className={styles['name']}>
              {item.profile && item.profile.name.substring(0, 15)}
              {item.profile.name.length > 15 ? '...' : null}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`
        ${styles['collection-item']} 
        ${empty ? styles['empty'] : ''}
        ${sliderItem ? styles['slider-item'] : ''}
      `}
      style={customStyle}
    >
      {!empty && <MediaItem item={data} />}
    </div>
  );
};

export default LiveShowCollection;
